import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

export const GroupLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font: 700 16px/1.2 ${getToken('font-family-title')};
  color: rgb(${getToken('color-success-60')});
  margin: 0 0 14px;

  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: rgb(${getToken('color-success-60')});
  }
`;
